<template>
    <div class="form-field form-field__input form-field__select"
            :class="[rootClasses]">
        <label class="form-field--title-label"
                v-if="label" :for="id"
                v-text="label">
        </label>
        <div class="form-field--input-container" :data-action-count="actionCount + 1">
            <select class="form-field--input"
                    ref="input"
                    v-if="isMounted"
                    v-bind="inputBindings"
                    @change="updateValue($event.target.value)"
                    @focus="onFocus"
                    @blur="onBlur">
                <option v-if="placeholder" disabled :selected="!value" value
                        v-html="placeholder">
                </option>
                <option v-for="item in uniqueItems" :key="item.id" :value="item.val"
                        v-html="item.label || item.val">
                </option>
            </select>
            <div class="form-field--actions">
                <span class="form-field--action form-field--action__arrow">
                    <cmp-icon symbol="chevron_down" size="x-small"></cmp-icon>
                </span>
            </div>
        </div>
        <cmp-form-field-messages-partial
                :messages="messages"
                :active-item="activeItem">
        </cmp-form-field-messages-partial>
    </div>
</template>

<script>
    import formFieldAbstractMixin from 'vue/mixins/form/form-field-abstract';
    import formFieldItemsMixin from 'vue/mixins/form/form-field-items';


    export default {
        mixins: [
            formFieldAbstractMixin,
            formFieldItemsMixin,
        ],
        props: {
            type: String,
            value: {
                type: [Array, String],
                required: true,
            },
        },
        computed: {
            specificRootClasses() {
                return {
                    'form-field__has-focus': this.hasFocus,
                    'form-field__is-empty': !this.value,
                    'form-field__is-hidden': this.state.hidden,
                };
            },
        },
    };
</script>



// WEBPACK FOOTER //
// index.vue?4368a9a0